import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
// eslint-disable-next-line import/named
import { CouncilViewList } from 'features/CouncilPrequalification/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function CouncilViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="project_proposal">
            <CouncilViewList />
          </Can>
          <Can not do="read" on="project_proposal">
            <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default CouncilViewListPage;
